// 所有帮助中心的博客分类
const BLOG_TYPE = [
  'Getting Started',
  'Network',
  'Password',
  'Function Setup',
  'Troubleshooting',
  'Orders & Shipping'
];

async function debugFetchArticlesByTagsAndNameCode(keyword) {
  // 使用 Storefront API 兼容的查询：通过 blogs 遍历搜索文章
  const query = `
    query SearchArticles($keyword: String!) {
      blogs(first: 30) {
        nodes {
          title
          handle
          articles(first: 50, query: $keyword) {
            nodes {
              title
              onlineStoreUrl
              image {
                url
              }
              blog {
                title
              }
            }
          }
        }
      }
    }
  `;

  try {
    const response = await fetch('/api/2026-01/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query,
        variables: { keyword: keyword } // 安全传参，避免注入
      })
    });

    if (!response.ok) {
      console.error('❌ 请求失败:', response.status, response.statusText);
      return;
    }

    const data = await response.json();

    if (data.errors) {
      console.error('❌ GraphQL 错误:', data.errors);
      return;
    }

    // 正确提取所有匹配的文章（扁平化）
    let allArticles = [];
    const blogs = data.data?.blogs?.nodes || [];
    // 只过滤出 帮助中心 相关联的博客 数组类型 BLOG_TYPE
    const filteredBlogs = blogs.filter(blog =>
      BLOG_TYPE.includes(blog.title)
    );
    for (const blog of filteredBlogs) {
      const articlesInBlog = blog.articles?.nodes || [];
      allArticles = allArticles.concat(articlesInBlog);
    }

    // 返回结果
    return allArticles;

  } catch (error) {
    console.error('💥 请求异常:', error);
    return [];
  }
}